import toast from "react-hot-toast";

const CommonToast = (message = 'Something went wrong') => {
  toast.error(message, {
    id: message, // Prevents duplicate toasts
  });
};

export default CommonToast;